import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _mutations, _actions;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import axios from 'axios';
import { API_GET_QUESTION_LIST, API_GET_QUESTION_LIST_NEW, API_SUBMIT_ANSWER } from '@/apis';
import { QUESTION_LIST, GET_QUESTION_LIST, GET_QUESTION_LIST_NEW, SUBMIT_ANSWER, SUBMIT_ANSWER_NEW, ANSWER_RESULT, TOGGLE_NEW_MODAL } from '@/constants/question';
var defaultLimitImage = 'https://p1.meituan.net/myvideodistribute/9b03d41bd07c6df580d137590821863927882.png';
var defaultLimitModalImage = 'https://p0.meituan.net/myvideodistribute/dc644bb52e099d61a7bfe045326228f97319.png';
var MUTATE_LIMITING_NEED_REDIRECT = 'MUTATE_LIMITING_NEED_REDIRECT';
var MUTATE_NEW_MODAL_STATUS = 'MUTATE_NEW_MODAL_STATUS';
export default {
  state: {
    questionList: [],
    // 是否已经拥挤的标志
    limitTap: null,
    // 拥挤的是否有倒计时
    hasLimitLayout: false,
    // 是否展示倒计时
    showLimitingModal: false,
    limitBackGroundImage: '',
    // 限流页面底图
    limitInterval: 0,
    limitButtonText: '',
    limitText: ''
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, QUESTION_LIST, function (state, payload) {
    state.questionList = payload;
    !payload.questionHint && (state.questionList.questionHint = '爱豆知识大比拼，通过考验后，才可顺利抢票哦！');
    //   console.log(state.questionList)
  }), _defineProperty(_mutations, ANSWER_RESULT, function (state, payload) {
    state.answerResult = payload;
  }), _defineProperty(_mutations, MUTATE_LIMITING_NEED_REDIRECT, function (state, _ref) {
    var tap = _ref.tap,
      limitBackGroundImage = _ref.limitBackGroundImage,
      limitInterval = _ref.limitInterval,
      limitButtonText = _ref.limitButtonText,
      limitText = _ref.limitText;
    state.limitTap = tap;
    state.limitBackGroundImage = limitBackGroundImage;
    state.limitInterval = limitInterval;
    state.limitButtonText = limitButtonText;
    state.limitText = limitText;
    if (tap === 'refresh') {
      state.hasLimitLayout = false;
    }
    if (tap === 'refresh_layout') {
      state.hasLimitLayout = true;
    }
  }), _defineProperty(_mutations, MUTATE_NEW_MODAL_STATUS, function (state, _ref2) {
    var showLimitingModal = _ref2.showLimitingModal,
      limitBackGroundImage = _ref2.limitBackGroundImage,
      hasLayout = _ref2.hasLayout,
      limitInterval = _ref2.limitInterval,
      limitButtonText = _ref2.limitButtonText,
      limitText = _ref2.limitText;
    state.showLimitingModal = showLimitingModal;
    state.limitBackGroundImage = limitBackGroundImage;
    state.hasLimitLayout = hasLayout;
    state.limitInterval = limitInterval;
    state.limitButtonText = limitButtonText;
    state.limitText = limitText;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, GET_QUESTION_LIST, function (_ref3, _ref4) {
    var commit = _ref3.commit;
    var performanceId = _ref4.performanceId,
      count = _ref4.count;
    axios.get("".concat(API_GET_QUESTION_LIST, "?performanceId=").concat(performanceId, "&count=").concat(count)).then(function (_ref5) {
      var code = _ref5.code,
        data = _ref5.data;
      if (code === 1407) {
        commit(MUTATE_LIMITING_NEED_REDIRECT, {
          tap: 'refresh',
          limitBackGroundImage: data.url || defaultLimitImage,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
      }
      if (code === 1414) {
        commit(MUTATE_LIMITING_NEED_REDIRECT, {
          tap: 'refresh_layout',
          limitBackGroundImage: data.url || defaultLimitImage,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
      }
      commit(QUESTION_LIST, data);
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, SUBMIT_ANSWER, function (_ref6, _ref7) {
    var commit = _ref6.commit,
      state = _ref6.state;
    var performanceId = _ref7.performanceId,
      choose = _ref7.choose;
    return axios({
      url: "".concat(API_SUBMIT_ANSWER),
      method: 'post',
      data: {
        'answerRequests': choose,
        'performanceId': performanceId
      },
      headers: {
        'Content-type': 'application/json'
      }
    }).then(function (_ref8) {
      var code = _ref8.code,
        msg = _ref8.msg,
        data = _ref8.data;
      if (code === 1407) {
        commit(MUTATE_NEW_MODAL_STATUS, {
          showLimitingModal: !state.showLimitingModal,
          limitBackGroundImage: data.url || defaultLimitModalImage,
          hasLayout: false,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
        return {
          limit: true,
          code: code,
          msg: msg,
          data: data
        };
      } else if (code === 1414) {
        commit(MUTATE_NEW_MODAL_STATUS, {
          showLimitingModal: !state.showLimitingModal,
          limitBackGroundImage: data.url || defaultLimitModalImage,
          hasLayout: true,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
        return {
          limit: true,
          code: code,
          msg: msg,
          data: data
        };
      }
      commit(ANSWER_RESULT, data);
      return {
        code: code,
        msg: msg,
        data: data
      };
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, GET_QUESTION_LIST_NEW, function (_ref9, _ref10) {
    var commit = _ref9.commit;
    var performanceId = _ref10.performanceId,
      count = _ref10.count;
    // ajax请求前缀
    var ajaxNewUrl = API_GET_QUESTION_LIST_NEW.replace('/myshow/', '/myshowquestion/');
    return axios.get("".concat(ajaxNewUrl, "?performanceId=").concat(performanceId, "&count=").concat(count)).then(function (_ref11) {
      var code = _ref11.code,
        data = _ref11.data;
      if (code === 1407) {
        commit(MUTATE_LIMITING_NEED_REDIRECT, {
          tap: 'refresh',
          limitBackGroundImage: data.url || defaultLimitImage,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
      }
      if (code === 1414) {
        commit(MUTATE_LIMITING_NEED_REDIRECT, {
          tap: 'refresh_layout',
          limitBackGroundImage: data.url || defaultLimitImage,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
      }
      commit(QUESTION_LIST, data);
    }).catch(function (error) {
      // todo: 完成查错后应移除此上报，上报方法应该集成到request 中间件
      var response = error.response,
        request = error.request;
      if (request) {
        // 针对请求错误上报
        var _url = request._url,
          _method = request._method,
          status = request.status,
          statusText = request.statusText,
          timeout = request.timeout,
          _response = request.response,
          responseText = request.responseText,
          responseType = request.responseType,
          responseURL = request.responseURL;
        try {
          window.seedAction({
            // 上报请求错误
            bid: 'b_movie_xr6y4gak_mv',
            evt: 'view',
            custom: {
              _url: _url,
              _method: _method,
              errorType: 'requestError',
              status: status,
              statusText: statusText,
              timeout: timeout,
              response: _response,
              responseText: responseText,
              responseType: responseType,
              responseURL: responseURL
            }
          });
        } catch (e) {}
      } else if (response) {
        // 针对返回错误做上报
        var data = response.data,
          _status = response.status,
          headers = response.headers;
        try {
          window.seedAction({
            // 上报返回错误
            bid: 'b_movie_xr6y4gak_mv',
            evt: 'view',
            custom: {
              data: data,
              status: _status,
              headers: headers,
              errorType: 'responseError'
            }
          });
        } catch (e) {}
      } else {
        // 上报一般错误
        try {
          window.seedAction({
            // 上报返回错误
            bid: 'b_movie_xr6y4gak_mv',
            evt: 'view',
            custom: {
              message: error.message,
              errorType: 'scriptError'
            }
          });
        } catch (e) {}
      }
    });
  }), _defineProperty(_actions, SUBMIT_ANSWER_NEW, function (_ref12, _ref13) {
    var commit = _ref12.commit,
      state = _ref12.state;
    var performanceId = _ref13.performanceId,
      choose = _ref13.choose;
    var ajaxNewUrl = API_SUBMIT_ANSWER.replace('/myshow/', '/myshowquestion/');
    return axios({
      url: "".concat(ajaxNewUrl),
      method: 'post',
      data: {
        'answerRequests': choose,
        'performanceId': performanceId
      },
      headers: {
        'Content-type': 'application/json'
      }
    }).then(function (_ref14) {
      var code = _ref14.code,
        msg = _ref14.msg,
        data = _ref14.data;
      if (code === 1407) {
        commit(MUTATE_NEW_MODAL_STATUS, {
          showLimitingModal: !state.showLimitingModal,
          limitBackGroundImage: data.url || defaultLimitModalImage,
          hasLayout: false,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
        return {
          limit: true,
          code: code,
          msg: msg,
          data: data
        };
      } else if (code === 1414) {
        commit(MUTATE_NEW_MODAL_STATUS, {
          showLimitingModal: !state.showLimitingModal,
          limitBackGroundImage: data.url || defaultLimitModalImage,
          hasLayout: true,
          limitInterval: data.interval,
          limitButtonText: data.buttonText,
          limitText: data.text
        });
        return {
          limit: true,
          code: code,
          msg: msg,
          data: data
        };
      }
      commit(ANSWER_RESULT, data);
      return {
        code: code,
        msg: msg,
        data: data
      };
    }).catch(function (err) {
      console.warn(err);
    });
  }), _defineProperty(_actions, TOGGLE_NEW_MODAL, function (_ref15) {
    var commit = _ref15.commit,
      state = _ref15.state;
    commit(MUTATE_NEW_MODAL_STATUS, !state.showLimitingModal);
  }), _actions),
  getters: {
    questionInfo: function questionInfo(state) {
      return state.questionList;
    },
    answerResult: function answerResult(state) {
      return state;
    },
    questionState: function questionState(state) {
      return state;
    }
  }
};